// TODO: detect if menu items are slotted and add class to ul

import { Component, h } from '@stencil/core';

@Component({
  tag: 'cwru-sub-nav',
  styleUrl: 'navigation.css',
  shadow: false,
})
export class SubNav {
  render() {
    return (
      <ul class="dropdown-menu" role="menuitem" aria-hidden="true" tabindex="-1">
        <slot />
      </ul>
    );
  }
}
